import { useTranslation } from 'react-i18next';
import { Grid } from 'bonfire-kindling';

import { useDashboardOverviewMetrics } from '../../hooks';
import DashboardOverviewMetricsCard from './DashboardOverviewMetricsCard';

export const DASHBOARD_OVERVIEW_TEST_IDS = {
  awarded: 'dashboard-overview-awarded-count',
  missed: 'dashboard-overview-missed-count',
  submitted: 'dashboard-overview-submitted-count',
  wip: 'dashboard-overview-wip-count',
  followed: 'dashboard-overview-followed-count',
  contracts: 'dashboard-overview-contracts-count',
};

const DashboardOverviewMetrics = () => {
  const { t } = useTranslation();
  const { submissionCounts, followedCount } = useDashboardOverviewMetrics();

  return (
    <Grid container spacing={{ xs: 2, md: 3 }}>
      <Grid item xs={6} lg>
        <DashboardOverviewMetricsCard
          title={t('dashboard.overview.metrics.following')}
          to="/dashboard/following"
          count={followedCount}
          testId={DASHBOARD_OVERVIEW_TEST_IDS.followed}
        />
      </Grid>
      <Grid item xs={6} lg>
        <DashboardOverviewMetricsCard
          title={t('dashboard.overview.metrics.wip')}
          to="/dashboard/wip"
          count={submissionCounts.wip}
          testId={DASHBOARD_OVERVIEW_TEST_IDS.wip}
        />
      </Grid>
      <Grid item xs={6} lg>
        <DashboardOverviewMetricsCard
          title={t('dashboard.overview.metrics.submitted')}
          to="/dashboard/submitted"
          count={submissionCounts.submitted}
          testId={DASHBOARD_OVERVIEW_TEST_IDS.submitted}
        />
      </Grid>
      <Grid item xs={6} lg>
        <DashboardOverviewMetricsCard
          title={t('dashboard.overview.metrics.awarded')}
          to="/dashboard/awarded"
          count={submissionCounts.awarded}
          testId={DASHBOARD_OVERVIEW_TEST_IDS.awarded}
        />
      </Grid>
      <Grid item xs={6} lg>
        <DashboardOverviewMetricsCard
          title={t('dashboard.overview.metrics.contracts')}
          to="/dashboard/contracts"
          count={submissionCounts.contracts}
          testId={DASHBOARD_OVERVIEW_TEST_IDS.contracts}
        />
      </Grid>
      <Grid item xs={6} lg>
        <DashboardOverviewMetricsCard
          title={t('dashboard.overview.metrics.missed')}
          to="/dashboard/missed"
          count={submissionCounts.missed}
          testId={DASHBOARD_OVERVIEW_TEST_IDS.missed}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardOverviewMetrics;
